import { EMPTY_HEART, FULL_HEART, VW } from "../../../../tiles";
import { GlyphBar } from "../../../../ui/dataInfo/GlyphBar";
import { ComponentF, createElement } from "../../../../ui/ui";
import Colors from "../../../Colors";
import { gameData } from "../../../GameManager";
import { FLOURISH_WIDTH } from "../SpellWand";

export const HealthBar: ComponentF<void> = (C) => {
  const x = VW / 2 - (gameData.player.maxLetters + FLOURISH_WIDTH) / 2 - 11;
  return [
    createElement(
      GlyphBar,
      { x: x, y: 0, w: 10, h: 1 },
      {
        full: FULL_HEART,
        empty: EMPTY_HEART,
        current: gameData.player.health.current,
        max: gameData.player.health.max,
        reverse: true,
        fullColor: Colors.PINK_4,
      }
    ),
  ];
};
